'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnpaidAccountBanner = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnpaidAccountBanner = exports.UnpaidAccountBanner = function UnpaidAccountBanner(_ref) {
  var displayedOnAngular = _ref.displayedOnAngular;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)({
        banner: !displayedOnAngular
      })
    },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'banner.unpaid.message',
      tagName: 'p',
      defaultMessage: 'Uh oh! We are unable to process payment for your upcoming membership month, and your account has been paused temporarily. Please contact your financial institution or update your credit card to reactivate your membership and keep working out!'
    }),
    _react2.default.createElement(
      'p',
      { className: 'mb0' },
      _react2.default.createElement(
        'a',
        { href: '/settings/billing' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'banner.unpaid.update',
          defaultMessage: 'Update your information'
        })
      )
    )
  );
};

UnpaidAccountBanner.propTypes = {
  displayedOnAngular: _propTypes2.default.bool
};